/** Resolution for a portal-builder customization text field with a legacy
 * fallback source. For text we always want a visible fallback, so empty
 * string is treated the same as missing — inherit from legacy. Image slots
 * use `resolveCustomizationImage` below, which preserves the "cleared"
 * semantics needed for image pickers.
 *
 *   - non-empty string in the new slot → use as-is
 *   - `""` / `null` / `undefined` / missing in the new slot → inherit from legacy
 */
export function resolveCustomizationField(
  slot: string | null | undefined,
  legacy: string | null | undefined,
): string {
  if (slot) return slot;
  return legacy || "";
}

/** Same three-state resolution as `resolveCustomizationField` but returns
 * `undefined` when the field is cleared or missing — so image pickers can
 * render their empty state instead of a broken `<img src="">`. */
export function resolveCustomizationImage(
  slot: string | null | undefined,
  legacy: string | null | undefined,
): string | undefined {
  if (slot === "") return undefined;
  if (slot) return slot;
  return legacy || undefined;
}
